'use client';

import { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide, SwiperRef, SwiperClass, SwiperProps } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { AutoplayOptions } from 'swiper/types';
import clsx from 'clsx';
import { useAccountInfo } from '@/hooks/query/account';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { KnockoutChildDisplayText } from '@nf/types/promotion-Tournament';
import { isDesktop } from 'react-device-detect';
import { KafkaNote } from '@nf/utils-common/constants';
interface SwiperContainerProps {
	slideElements: React.ReactNode[];
	slideElementsBetTypeIds?: number[];
	className?: string;
	elementClassName?: string;
	currentIndex?: number;
	onSlideClick?(index: number): void;
	defaultIdx?: number;
	inPlayCheck?: boolean[];
	slidesPerView?: number;
	breakPoints?: Record<number, { slidesPerView: number }>;
	spaceBetween?: number;
	centeredSlides?: boolean;
	isMyBetHasBooked?: boolean;
	enableNavigation?: boolean;
	autoPlayOption?: AutoplayOptions;
	kafkaType?: KafkaType;
	slideTitle?: string[];
	isKnockOut?: boolean;
	setCurrentKnockOut?(currentKnockOut: string): void;
	customProps?: Partial<SwiperProps>;
	disableOnClickIdx?: Array<number>;
}

type KafkaType = 'promotion';

export const SwiperContainer = ({
	slideElements,
	slideElementsBetTypeIds,
	className,
	elementClassName,
	currentIndex,
	onSlideClick,
	inPlayCheck,
	slidesPerView,
	breakPoints,
	spaceBetween,
	centeredSlides,
	slideTitle,
	isKnockOut,
	setCurrentKnockOut,
	isMyBetHasBooked,
	enableNavigation,
	autoPlayOption,
	kafkaType,
	customProps,
	disableOnClickIdx,
}: SwiperContainerProps) => {
	const [instance, setInstance] = useState<SwiperClass | null>(null);
	const [currentIdx, setCurrentIdx] = useState(currentIndex);
	const [isTabStart, setIsTabStart] = useState(true);
	const [isTabEnd, setIsTabEnd] = useState(false);
	const isCriketSpecialBetType = [9538, 9539];
	const swiperRef = useRef<SwiperRef>(null);

	const setIsTabStartEnd = () => {
		setIsTabStart(Boolean(swiperRef.current?.swiper.isBeginning));
		setIsTabEnd(Boolean(swiperRef.current?.swiper.isEnd));
	};
	const { user } = useAccountInfo();
	useEffect(() => {
		setIsTabStartEnd();
	}, [instance]);

	useEffect(() => {
		setCurrentIdx(currentIndex)
		if (isKnockOut) {
			swiperRef.current?.swiper.slideTo(currentIndex || 0);
		} else {
			swiperRef.current?.swiper.slideTo(currentIndex || 0, 0, false);
		}
	}, [currentIndex])

	useEffect(() => {
		if (isKnockOut) {
			if (isDesktop) {
				swiperRef.current?.swiper.disable();
			} else {
				swiperRef.current?.swiper.enable();
			}
		}
	}, [isDesktop]);

	const handleChange = (index: number, isDisable?: boolean) => () => {
		!isDisable && setCurrentIdx(index);
		onSlideClick?.(index);
	};

	const handleKafka = (navigationType: string) => {
		if (!enableNavigation) {
			return;
		}
		if (kafkaType === 'promotion') {
			const kafkaData = {
				type: 2,
				note: KafkaNote.EuroCup,
				action: navigationType === 'prev' ? 3 : 4,
			};
			setKafkaNormal(kafkaData);
		}
	}

	const handleSlideChange = (swiper: any) => {
		
		if (isKnockOut) {
			setCurrentIdx(swiper.realIndex);
			const currentKnockOutEntry = Object.entries(KnockoutChildDisplayText).find(
				([key, value]) => value[1] === swiper.realIndex
			);
			if (setCurrentKnockOut && currentKnockOutEntry) {
				setCurrentKnockOut(currentKnockOutEntry[0]);
			}
		}

	}

	
	return (
		<>
			<Swiper
				ref={swiperRef}
				className={clsx(className)}
				data-to-start={isTabStart}
				data-to-end={isTabEnd}
				onSwiper={setInstance}
				onTouchMove={setIsTabStartEnd}
				slidesPerView={slidesPerView || 'auto'}
				spaceBetween={spaceBetween}
				centeredSlides={centeredSlides}
				breakpoints={breakPoints}
				navigation={enableNavigation ?? false}
				autoplay={autoPlayOption ?? false}
				onNavigationPrev={() => handleKafka('prev')}
				onNavigationNext={() => handleKafka('next')}
				onSlideChange={(swiper) => handleSlideChange(swiper) }
				data-active={currentIndex}
				modules={[Navigation, Autoplay, Pagination]}
				{...(customProps ?? {})}
			>
				{slideElements.map((item, index) => (
					<SwiperSlide
						key={`slide${index}`}
						className={
							isCriketSpecialBetType.includes(slideElementsBetTypeIds ? slideElementsBetTypeIds[index] : 0) ? `${elementClassName} match__bettype--fancy` : 
								(index == 0 && isMyBetHasBooked) ? `${elementClassName} tab__item--special` :
									elementClassName
						}
						data-selected={currentIdx === index}
						data-inplay={inPlayCheck ? inPlayCheck[index] : false}
						onClick={handleChange(index, disableOnClickIdx?.includes(index))}
						data-title={ isKnockOut && slideTitle ? slideTitle[index] : ''}
					>
						{item}
					</SwiperSlide>
				))}
			</Swiper>
		</>

	);
};